import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { Select, type SelectProps } from '@/components/ui/select';

export const SelectController = <T extends FieldValues>({
  name,
  methods,
  ...selectProps
}: Omit<SelectProps, 'onChange' | 'value'> & {
  name: Path<T>;
  methods: UseFormReturn<T>;
}) => {
  return (
    <Controller
      {...methods}
      name={name}
      render={({ field: { value, ...field }, fieldState: { error } }) => {
        if (selectProps.multiple) {
          const val = value !== undefined ? (Array.isArray(value) ? value : [value]) : [];
          return (
            <Select
              {...selectProps}
              {...field}
              value={val}
              disableCloseOnSelect={undefined}
              errors={error?.message ? [error.message] : undefined}
              multiple
            />
          );
        }
        return (
          <Select
            {...selectProps}
            {...field}
            multiple={false}
            value={value !== undefined ? String(value) : undefined}
            errors={error?.message ? [error.message] : undefined}
          />
        );
      }}
    />
  );
};
